import { Flex } from '@/components/base';
import Heading from '@/components/Typography/Heading';

const CompanyUploadPage = () => {
  return (
    <Flex style={{ padding: '16px 24px' }}>
      <Heading type="h3">Account upload</Heading>
    </Flex>
  );
};

export default CompanyUploadPage;
